// Path: src/utils/jalaaliHelper.js
import { toJalaali, toGregorian } from 'jalaali-js';

const pad = (n) => String(n).padStart(2, '0');

// ورودی: YYYY-MM-DD (گرگوری) -> خروجی: "YYYY/MM/DD" هجری جلالی (فارسی)
export function gregorianToJalaaliString(gregorianDateIso) {
  if (!gregorianDateIso) return '';
  const d = new Date(gregorianDateIso);
  if (Number.isNaN(d.getTime())) return '';
  const gY = d.getFullYear(), gM = d.getMonth() + 1, gD = d.getDate();
  const { jy, jm, jd } = toJalaali(gY, gM, gD);
  return `${jy}/${pad(jm)}/${pad(jd)}`;
}

// ورودی: jY/jM/jD as "YYYY/MM/DD" یا "YYYY-MM-DD" -> خروجی: "YYYY-MM-DD" میلادی (ISO date)
export function jalaaliStringToGregorianIso(jalaaliStr) {
  if (!jalaaliStr) return '';
  const s = jalaaliStr.replace(/-/g, '/').trim();
  const parts = s.split('/');
  if (parts.length !== 3) return '';
  const jy = parseInt(parts[0], 10), jm = parseInt(parts[1], 10), jd = parseInt(parts[2], 10);
  if ([jy, jm, jd].some(x => Number.isNaN(x))) return '';
  const { gy, gm, gd } = toGregorian(jy, jm, jd);
  return `${gy}-${pad(gm)}-${pad(gd)}`;
}

// ورودی: Date object یا ISO -> خروجی ISO date (YYYY-MM-DD)
export function toIsoDateOnly(input) {
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}
